import { isPlainObject } from "./typeGuards";

/**
 * Deep equality check for plain objects, arrays, dates, and primitives.
 * Does not handle Map, Set, RegExp, typed arrays, or circular references.
 */
export function isEqual(a: unknown, b: unknown): boolean {
    if (Object.is(a, b)) {
        return true;
    }

    if (
        a === null ||
        b === null ||
        typeof a !== "object" ||
        typeof b !== "object"
    ) {
        return false;
    }

    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }

    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) {
            return false;
        }
        return a.every((item, index) => isEqual(item, b[index]));
    }

    if (Array.isArray(b)) {
        return false;
    }

    if (!isPlainObject(a) || !isPlainObject(b)) {
        return false;
    }

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) {
        return false;
    }

    return keysA.every(
        (key) =>
            Object.prototype.hasOwnProperty.call(b, key) &&
            isEqual(a[key], b[key]),
    );
}
